module.exports = __webpack_public_path__ + "media/images/space-icon-6ce93493.svg";